import { useMutation, useQuery } from '@tanstack/react-query';
import MessagesAPI from '../fetch/messagesApi';
import type { ChatMessage } from '../types';
import queryClient from '../../utils/queryClient';

const threadKey = ['messages', 'thread'] as const;
const unreadKey = ['messages', 'unread'] as const;

export const useMessageThread = (enabled = true) =>
  useQuery<ChatMessage[]>({ queryKey: threadKey, queryFn: MessagesAPI.getThread, enabled });

export const useUnreadMessageCount = (enabled = true) =>
  useQuery<{ count: number }>({ queryKey: unreadKey, queryFn: MessagesAPI.unreadCount, enabled });

export const invalidateMessages = () => {
  void queryClient.invalidateQueries({ queryKey: threadKey });
  void queryClient.invalidateQueries({ queryKey: unreadKey });
};

export const useSendMessage = () =>
  useMutation({
    mutationFn: (body: string) => MessagesAPI.send(body),
    onSuccess: () => invalidateMessages(),
  });

export const useMarkMessagesRead = () =>
  useMutation({
    mutationFn: () => MessagesAPI.markRead(),
    onSuccess: () => invalidateMessages(),
  });
